// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess
} from "@insite/client-framework/HandlerCreator";
import { updateCart } from "@insite/client-framework/Services/CartService";
import { CreateQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/CreateOrRequestQuote";
import { QuoteModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess<QuoteModel> & HasOnError<string>,
    CreateQuoteApiParameter,
    QuoteModel
>;

export const XngUpdateCart: HandlerType = async (props) => {
    await updateCart({ cart: (props.parameter as any).cart });
};

addToChainAfter(chain, PopulateApiParameter, XngUpdateCart);